import { render, staticRenderFns } from "./UserAgreementFrame.vue?vue&type=template&id=a47dd458&"
import script from "./UserAgreementFrame.vue?vue&type=script&lang=js&"
export * from "./UserAgreementFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports